import { get } from "../../pwa/ajax";
import * as BucketTools from "../common/bucket";

const urlBucket = window.config.Statics.BucketUrl;
let liveFireUrlApi = window.config.Statics.ApiLiveFireUrl;
const siteIdLF = window.config.Statics.SiteIdLF;
const urlAcuTema = window.config.Statics.ApiContenidoUrlRoot + window.config.Statics.ApiAcumuladoTemasUrl;
const sitioId = window.config.Sitio.Id;

const getMasComentadas = (data) => {
    let masComentadas = document.querySelector('section[data-id="masComentadas"]');
    if (masComentadas !== null) {
        if(data !== null && data.data !== null && data.data.length > 0){
            let html = `<div class="techo floatFix">
                        <h4>Más <b>comentadas</b></h4>
                    </div>
                    <ol>`;
            let toi = 601;
            for (let nota of data.data.slice(0,5)) {
                let parts = nota.url.split('/');
                let url = parts.pop();
                let idNota = url.split("-")[0];
                let toiPos = "toi".concat(toi.toString());
            //<img src="http://bucket1.glanacion.com/anexos/fotos/16/tecnologia-2086816w122h82.jpg " />
                html += `<li>
                    <article title="" class="nota floatFix" data-id="${idNota}" data-notaid="${idNota}" data-source="livefyre" data-pos="${toiPos}">                        
                        <h2>
                            <a href="/${url}">${nota.title}</a>
                        </h2>
                    </article>
                    </li>`;
                toi++;
            }  

            html += `</ol>`;
            masComentadas.innerHTML = html;
        }
    }
}

export const notasMasComentadas = () => {
    let masComentadas = document.querySelector('section[data-id="masComentadas"]');
    if (masComentadas !== null) {
        liveFireUrlApi = liveFireUrlApi.replace("{livefyre-domainName}", "la-nacion");
        liveFireUrlApi = liveFireUrlApi.replace("{SiteId_Livefyre}", siteIdLF);
        liveFireUrlApi = liveFireUrlApi.replace("{cantidad de notas}", 10);

        get(liveFireUrlApi)
            .then(rs => JSON.parse(rs))
            .then(getMasComentadas);
    }
}


const renderNotasAdemas = (data) => {
    let nodoAdemas = document.querySelector('#listadoAdemas');
    let listNotas = [];
    const notaId = document.querySelector('div[data-notaid]').getAttribute("data-notaid");
    if (data !== undefined && data != null && nodoAdemas !== null && nodoAdemas !== undefined) {
        for (let obj in data) {
            if (data.hasOwnProperty(obj)) {
                data[obj].items.filter(function(item) {
                    if (!(item.id == notaId || !(item.imagenes instanceof Array) || !item.imagenes.length > 0 || 
                        !item.imagenes[0].src || item.imagenes[0].src == "")) {
                        if (listNotas.length < 2) {
                            listNotas.push(item);
                        } else {
                            return listNotas;
                        }
                    }
                    if (listNotas.length > 1) {
                        return listNotas;
                    }
                    return listNotas;
                });
            }
        }

        if (listNotas.length < 1) {
            //nodoAdemas.remove();
            nodoAdemas.parentNode.removeChild(nodoAdemas);
            return false;
        }
        if (listNotas.length == 1) {
            nodoAdemas.classList.add("uno");
        }

        let html = `<div class="techo"> ADEMÁS </div><div>`;
        //<!-- pueden venir hasta 2 articles-->
        let toi = 651;
     //  let arrayNotasDinamicas = listNotas.splice(0, 2);
       for (let nota of listNotas) {
            let imageHtml = `<a class="figure" href="/${nota.url}">       
                                <img src="${BucketTools.urlBucketBalance(urlBucket, nota.imagenes[0].src, "82")
                         }"/>                   
                              </a>`;
                
            let toiPos = "toi".concat(toi.toString());
            html += `<article title="" class="nota foto floatFix" data-id="${nota.id}" data-notaid="${nota.id}" data-source="ultimas" data-pos="${toiPos}">
                ${imageHtml}
                <h2>
                    <a href="/${nota.url}">
                        ${nota.titulo}
                    </a>
                </h2>
                </article>`;
            toi++;
        }

       html += `</div>`;
        nodoAdemas.innerHTML = html;

    } else {
        if (nodoAdemas !== null && nodoAdemas !== undefined) {
            nodoAdemas.remove();
        }
        
    }
}



export const notasAdemas = () => {
    if (document.querySelector('div[data-tagsIds]')) {
        const cantNotas = 5;
        const fechaHoy = 120;
     
        let tagsId = document.querySelector('div[data-tagsIds]').getAttribute('data-tagsIds');
        if ( tagsId == "" || tagsId == null)
            return;
    
        let url = urlAcuTema + tagsId + "?&c=" + cantNotas + "&s=" + sitioId + "&h=" + fechaHoy;
  
        get(url)
            .then(rs => JSON.parse(rs))
            .then(renderNotasAdemas); 
    }
}


// WEBPACK FOOTER //
// ./Statics/scripts/nota/notasAdicionales.js